const locale = {
  appName: 'Kiness',
  tagline: '連結家人，溫暖相伴',
  signIn: '登入',
  signUp: '註冊',
  signOut: '登出',
  email: '電子郵件',
  password: '密碼',
  name: '姓名',
  facilityCode: '機構代碼',
  facilityCodeHint: '請向護理機構索取此代碼',
  noAccount: '還沒有帳號？',
  haveAccount: '已有帳號？',
  signingIn: '登入中…',
  creatingAccount: '註冊中…',
  loginError: '無法登入 — 請檢查電郵和密碼',
  registerError: '無法註冊 — 請重試',
  welcomeBack: '歡迎回來',
  welcomeNew: '加入您的護理社區',
  selectResident: '本次更新關於哪位住戶？',
  updatePlaceholder: '{name} 今天怎麼樣？',
  addPhoto: '添加照片',
  postUpdate: '發佈更新',
  posting: '發佈中…',
  postSuccess: '更新已發佈 — 家屬將收到通知',
  postError: '無法發佈更新 — 請檢查網絡後重試',
  yourLovedOne: '您的親人',
  familyFeed: '家人動態',
  tabFeed: '動態',
  tabRecord: '記錄',
  tabCalendar: '日曆',
  tabPhotos: '照片',
  noUpdates: '暫無更新 — 請稍後再來',
  pullRefresh: '下拉刷新',
  refreshing: '刷新中…',
  admin: '管理',
  dashboard: '概覽',
  residents: '住戶',
  familyLinks: '家屬關聯',
  staff: '員工',
  facility: '機構',
  residentsCount: '住戶人數',
  familyLinked: '已關聯家屬',
  updatesToday: '今日更新數',
  addResident: '添加住戶',
  editResident: '編輯',
  removeResident: '刪除',
  firstName: '名',
  lastName: '姓',
  room: '房間號',
  save: '保存',
  cancel: '取消',
  addFamilyEmail: '通過電郵添加家屬',
  addStaffEmail: '通過電郵添加員工',
  staffAdd: '添加',
  staffCount: '共 {count} 名員工',
  relationship: '關係',
  inviteSent: '邀請已就緒 — 對方可用機構代碼註冊',
  loading: '載入中…',
  installTitle: '將 Kiness 添加到主畫面',
  installBody: '快速查看您親人的最新動態',
  installButton: '添加到主畫面',
  installDismiss: '暫不',
  language: '語言',
  chooseLanguage: '選擇您的語言',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: '之後可隨時通過地球圖標更改',
  english: 'English',
  chinese: '中文',
  newUpdate: '新動態',
  from: '來自',
  roomLabel: '房間',
  confirmRemove: '確定刪除此住戶？',
  staffPostTitle: '發佈更新',
  adminTitle: '機構管理',
  linkedFamily: '已關聯家屬',
  pendingInvite: '待註冊',
  noResidents: '暫無住戶 — 請添加第一位住戶',
  noStaff: '暫無員工',
  photoOptional: '照片（可選）',
  dashboardSettingUp: '正在設置您的面板…',
  dashboardEmptyHint: '添加第一位住戶即可開始',
};

export default locale;
